// Register the app-shell service worker — web only.
//
// Capacitor (iOS/Android) loads from a packaged WebView bundle; Electron loads
// from a local http server reading the same bundle off disk. Neither needs an
// SW to be offline-capable, and registering one in those contexts only adds
// confusion (stale caches surviving a Capgo live update, e.g.). So we gate
// strictly to plain web.

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (window.electronAPI) return;
  const cap = window.Capacitor;
  if (cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform()) return;

  // Defer to 'load' so registration doesn't fight with the initial paint.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      // Don't pull in logger here — SW registration runs once and the logger
      // would just batch this to telemetry, which is overkill for a failure
      // that's almost always "browser doesn't allow SWs in this context."
      console.warn('[sw] registration failed', err);
    });
  });
}
